import { render, staticRenderFns } from "./AreaMangeAdd.vue?vue&type=template&id=5a27a229&scoped=true"
import script from "./AreaMangeAdd.vue?vue&type=script&lang=js"
export * from "./AreaMangeAdd.vue?vue&type=script&lang=js"
import style0 from "./AreaMangeAdd.vue?vue&type=style&index=0&id=5a27a229&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27a229",
  null
  
)

export default component.exports